import React from 'react';
import Modal from './Modal';

export default function PromoModal({ promo, lang, onClose, onConfirm }) { 
  if (!promo) return null;

  const title = promo.title?.[lang] ?? promo.title ?? '';
  const body = promo.body?.[lang] ?? promo.body ?? '';
  const confirmText = promo.confirmText?.[lang] ?? promo.confirmText ?? (lang === 'ru' ? 'Перейти' : 'Перейти');

  return (
    <Modal
      title={title}
      onClose={onClose}
      onConfirm={onConfirm}
      confirmText={confirmText}
      hideCancel={false}
    >
      {promo.imageUrl && (
        <img
          src={promo.imageUrl}
          alt=""
          style={{ width: '100%', borderRadius: 12, marginBottom: 12 }}
        />
      )}
      <div>{body}</div>
    </Modal>
  );
}

